import {
  Box,
  Button,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Text,
} from '@chakra-ui/react'
import { Calendar, Filter, Search } from 'lucide-react'

type Props = {
  search?: string
  onSearchChange?: (value: string) => void
  onOpenFilters?: () => void
  sort?: string
  onSortChange?: (value: string) => void
}

export function TaskFiltersBar({
  search,
  onSearchChange,
  onOpenFilters,
  sort = 'recent',
  onSortChange,
}: Props) {
  return (
    <HStack
      w="full"
      spacing={3}
      justify="space-between"
      flexWrap="wrap"
    >
      {/* LEFT SIDE */}
      <HStack spacing={3} flexWrap="wrap">
        {/* Search */}
        <InputGroup maxW="280px">
          <InputLeftElement pointerEvents="none" color="gray.400">
            <Search size={16} />
          </InputLeftElement>
          <Input
            size="sm"
            placeholder="Search"
            value={search}
            onChange={(e) => onSearchChange?.(e.target.value)}
          />
        </InputGroup>

        {/* Date Range (UI-only for now) */}
        <Button
          size="sm"
          variant="outline"
          leftIcon={<Calendar size={16} />}
        >
          <Text fontWeight="500" fontSize="sm">
            27 May 2025 - 02 Jun 2025
          </Text>
        </Button>
      </HStack>

      {/* RIGHT SIDE */}
      <HStack spacing={3}>
        <Button
          size="sm"
          variant="outline"
          leftIcon={<Filter size={16} />}
          onClick={onOpenFilters}
        >
          Filter
        </Button>

        <Select
          size="sm"
          value={sort}
          onChange={(e) => onSortChange?.(e.target.value)}
          maxW="160px"
        >
          <option value="recent">Sort By: Recent</option>
          <option value="oldest">Sort By: Oldest</option>
          <option value="priority">Sort By: Priority</option>
        </Select>
      </HStack>
    </HStack>
  )
}
